import React from 'react';
import { PlusIcon } from 'lucide-react';
import type { FaqItem } from '../data/faq';
interface FaqListProps {
  items: FaqItem[];
}
export function FaqList({
  items
}: FaqListProps) {
  return <div className="divide-y-2 divide-ink/10 border-y-2 border-ink/10" data-id="element-121" data-mp="2637iefx6dfo4">
      {items.map(item => <details key={item.question} className="group" data-id="element-122" data-mp="2155rx9xf6e2m">
          <summary className="flex cursor-pointer items-center justify-between gap-6 py-5 font-display text-[19px] leading-snug text-ink md:text-[21px]" data-id="element-123" data-mp="216qiypkizevq">
            {item.question}
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 border-ink bg-white transition-transform duration-200 ease-out group-open:rotate-45" data-id="element-124" data-mp="1sb13ex5rdeq9">
              <PlusIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-125" data-mp="1ifhc6o25347u" />
            </span>
          </summary>
          <p className="max-w-3xl pb-6 text-[17px] text-ink-soft" data-id="element-126" data-mp="1dea4eozzy516">{item.answer}</p>
        </details>)}
    </div>;
}